export class PageQuestion {
  Page_no: number;
  QID: number;
}

export class PostMessgesData {
  action: string;
  data: string;
  height: number;
  width: number;
  embedid: number;
}
